<script>
import {mapGetters} from "vuex";

export default {
    methods: {
        $planning_needs_update(planning) {
            if (!this.latestEnforcedUpdateNotification || !this.latestEnforcedUpdateNotification.enforce_planning_updates) return false;

            if (planning && planning.configurator_update_deadline && this.latestEnforcedUpdateNotification) {
                return new Date(planning.configurator_update_deadline) < new Date(this.latestEnforcedUpdateNotification.update_date);
            } else {
                return true;
            }
        },
        $project_plannings_need_update(plannings) {
            if (plannings) {
                return plannings.filter(planning => this.$planning_needs_update(planning)).length > 0;
            } else {
                return false;
            }
        },
    },
    computed: {
        ...mapGetters({
            latestEnforcedUpdateNotification: 'updateNotification/latestEnforcedUpdateNotification',
        }),
    },
};
</script>
